"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bar = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const barContainer = (0, styled_components_1.css) `
  background-color: ${({ theme }) => theme.backgroundContainer};
  border-radius: ${({ theme }) => theme.borderRadius};
`;
const barProgress = (0, styled_components_1.css) `
  background: ${({ theme, value }) => value >= 100 ? theme.backgroundComplete : theme.backgroundFiller};
  border-radius: ${({ theme }) => theme.borderRadius};
  transition: ${({ theme }) => theme.transitionSpeedProgressBar} width linear;
`;
const Bar = styled_components_1.default.progress `
  appearance: none;
  box-sizing: border-box;
  height: ${({ theme }) => theme.height};
  margin-bottom: ${({ theme }) => parseInt(theme.height, 10) - 1}px;
  overflow: hidden;
  width: 100%;

  border: ${({ theme }) => `${theme.borderSize} ${theme.borderStyle} ${theme.borderColor}`};

  ${barContainer}
  &::-webkit-progress-bar {
    ${barContainer}
  }

  &::-webkit-progress-value {
    ${barProgress}
  }
  &::-moz-progress-bar {
    ${barProgress}
  }
`;
exports.Bar = Bar;
